export const getDetachedStorageKeys = (mainWindowName: string) => {
  const prefix = `reading:${encodeURIComponent(mainWindowName)}`;

  return {
    closed: `${prefix}:tab-closed`,
    afterSubmitRedirect: `${prefix}:after-submit-redirect`,
  };
};
